module.exports = __webpack_public_path__ + "img/ic_notification_settings.d3a979b5.svg";